import util from '../../common/util';
function install(Vue) {
    let locationParams = {};
    if (!util.inNode()) {
        // 与koa中保持一致
        locationParams = {
            url: `${location.pathname}${location.search}`,
            origin: `${location.protocol}//${location.host}`,
            href: location.href.split('#')[0],
            path: location.pathname,
            pathname: location.pathname,
            query: util.getQueryField(),
            querystring: location.search.slice(1),
            hostname: location.hostname,
            protocol: location.protocol
        };
    }
    Vue.mixin({
        beforeCreate() {
            // 组件混入_koaLocation,_isPageSpeed是否是lighthouse跑分代理
            if (!util.inNode()) {
                this._koaLocation = locationParams;
                this._isPageSpeed = false;
            } else {
                // root
                const options = this.$parent ? this.$root : this.$options;
                const { _koaLocation, _isPageSpeed } = options;
                Object.assign(this, { _koaLocation, _isPageSpeed });
            }
        },
        created() {
            if (this.$parent && 'asyncDataLoaded' in this.$parent) {
                this.asyncDataLoaded = this.$parent.asyncDataLoaded;
            }
        },
        /**
         * 为了兼容非首屏的asyncData
         * ssr首屏渲染的模块 asyncDataLoaded = true 避免客户端二次调用asyncData
         * 客户端非ssr asyncDataLoaded = false  调用asyncData
         */
        beforeMount() {
            // 已经被服务端渲染的模块不需要再次调用asyncData
            if (this.asyncDataLoaded) {
                return;
            }
            const isBlockRoot = this.isBlockRoot;
            const asyncData = this.$options.asyncData;
            if (typeof asyncData === 'function' && isBlockRoot) {
                const rootVm = this.$root;
                const modules = rootVm.moduleData;
                const moduleData = modules.find(item => this.id === item.id);
                this.asyncDataPromise = asyncData({
                    app: rootVm,
                    store: this.$store,
                    modules,
                    moduleData,
                    data: moduleData.data,
                    blockStoreName: this.$storeName,
                    isBlockRoot: true,
                    location: locationParams
                });
            } else {
                if (this.$parent && this.$parent.asyncDataPromise) {
                    this.asyncDataPromise = this.$parent.asyncDataPromise;
                }
            }
        }
    });
}

export default install;
